import { money } from './units';
import { jsPDF } from 'jspdf';
import { scafState } from './inspect';
import { clean, safeName } from './exporters';
import { APP_INFO } from './license';

const CLR = { green: [22, 163, 74], yellow: [202, 138, 4], red: [220, 38, 38], done: [100, 116, 139], doneOver: [220, 38, 38], none: [148, 163, 184] };
const eur = (v) => money(Math.round(v || 0));
const lbl = (s) => clean(String(s || '').replace(/^[^\p{L}\d]+/u, ''));

// one-page overview of all scaffolds: traffic light, rental end, base rent, extra cost, totals
export function scaffoldPdf(t, project) {
  const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'landscape' });
  const M = 12, W = 273, dt = (v) => (v ? new Date(v).toLocaleDateString(t.locale) : '-');
  doc.setFillColor(15, 23, 42); doc.rect(0, 0, 297, 22, 'F');
  doc.setTextColor(255); doc.setFont('helvetica', 'bold'); doc.setFontSize(15);
  doc.text(clean(`${t.scRentTitle}${project.title ? ` - ${project.title}` : ''}`), M, 10);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
  doc.text(clean([APP_INFO.name, project.address, new Date().toLocaleString(t.locale)].filter(Boolean).join(' · ')), M, 17);
  const cols = [[t.scName, 46], [t.scStart, 28], [t.scWeeksShort, 12], [t.scPrice, 22], [t.scDue, 26], [t.scEnd, 28], [t.kkResult, 44], [t.scBase, 27], [t.scExtra, 40]];
  let y = 32;
  const row = (cells, bold, rgb) => {
    doc.setFont('helvetica', bold ? 'bold' : 'normal'); doc.setFontSize(bold ? 8.5 : 8.8); doc.setTextColor(20);
    if (rgb) { doc.setFillColor(...rgb); doc.circle(M + 2, y - 1.3, 1.8, 'F'); }
    let x = M + 6;
    cells.forEach((c, i) => { if (rgb && i === 6) doc.setTextColor(...rgb); doc.text(clean(String(c)).slice(0, 40), x, y, { maxWidth: cols[i][1] - 2 }); doc.setTextColor(20); x += cols[i][1]; });
    y += 7; doc.setDrawColor(226, 232, 240); doc.line(M, y - 4.5, M + W, y - 4.5);
  };
  row(cols.map((c) => c[0]), true);
  let base = 0, extra = 0;
  const list = (project.scaffolds || []).map((s) => ({ s, r: scafState(s) }));
  list.forEach(({ s, r }) => {
    if (y > 180) return;
    base += r.base || 0; extra += r.extra || 0;
    const left = r.st === 'none' ? '' : r.left >= 0 ? ` (${t.scLeft.replace('{n}', r.left)})` : ` (${t.scOver.replace('{n}', r.over)})`;
    row([s.name || '', dt(s.start), s.weeks || '-', s.price ? eur(s.price) : '-', r.due ? dt(r.due) : '-', dt(s.end), `${lbl(t['scSt_' + r.st])}${s.end ? '' : left}`, r.st === 'none' ? '-' : eur(r.base), r.extra ? `${r.extraW} x = ${eur(r.extra)}` : '-'], false, CLR[r.st]);
  });
  y += 3;
  doc.setFont('helvetica', 'bold'); doc.setFontSize(10.5);
  doc.text(clean(`${t.scBase}: ${eur(base)}   ·   ${t.scExtra}: ${eur(extra)}   ·   ${t.scTotal}: ${eur(base + extra)}`), M, y);
  y += 8;
  doc.setFont('helvetica', 'normal'); doc.setFontSize(8); doc.setTextColor(71, 85, 105);
  ['green', 'yellow', 'red', 'done', 'doneOver'].forEach((k, i) => { doc.setFillColor(...CLR[k]); doc.circle(M + 2 + i * 52, y - 1.2, 1.6, 'F'); doc.text(lbl(t['scSt_' + k]), M + 6 + i * 52, y); });
  doc.setFontSize(7); doc.text(clean(`${APP_INFO.name} · ${list.length} ${t.scRentTitle}`), M, 202);
  doc.save(`${safeName(`Geruest-Uebersicht ${project.title || ''}`)}.pdf`);
}
